import { render, staticRenderFns } from "./QuestionCategoryWA.vue?vue&type=template&id=3d70cf0a&scoped=true"
import script from "./QuestionCategoryWA.vue?vue&type=script&lang=js"
export * from "./QuestionCategoryWA.vue?vue&type=script&lang=js"
import style0 from "./QuestionCategoryWA.vue?vue&type=style&index=0&id=3d70cf0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d70cf0a",
  null
  
)

export default component.exports